// extracted by mini-css-extract-plugin
export default {"sliderControlInner":"slider-control__sliderControlInner___1CYIL","iconLeft":"slider-control__iconLeft___pTwzK","iconRight":"slider-control__iconRight___1PQbG"};